// Keep this allowlist shared by SDK configuration and the feedback entry point.
export function teacherPage(pathname) {
  // Cloudflare Pages redirects *.html links to these extensionless paths.
  return ({
    '/teachers': 'library',
    '/teachers.html': 'library',
    '/teachers/lesson': 'lesson',
    '/teachers/lesson.html': 'lesson',
    '/teachers/guide': 'guide',
    '/teachers/guide.html': 'guide',
  })[pathname] || null;
}
